import { RpcService } from '@holmescorp/rpc';

export interface Question {
	id: number;
	root_id: number;
	posted: string;
	subject: string | null;
	author_id: string;
	recipient_id: number | null;
	session_id: number;
	message: string;
	fullname: string;
	replies: Array<Question>;
	latest_reply: Question;
	latest_reply_posted: string;
	recipient_replied: boolean;
	message_viewed: false;
}

export interface Message {
	reply: boolean;
	author_id: string;
	to_instructor: boolean;
	message: string;
	root_id?: number;
	[other: string]: any;
}

export declare interface IConversationsService extends RpcService {
	conversations(param: {
		session_id?: number;
		author_id?: string;
		select?: Record<string, unknown>;
	}): Promise<Question[]>;
	update_conversations(param: {
		session_id?: number;
		data: Message;
		select?: Record<string, unknown>;
	}): Promise<Question[]>;
}

export const svc: IConversationsService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/reports/@@group.rpc`,

	services: {
		conversations: {
			parameters: [
				{ name: 'session_id', type: 'integer', optional: false },
				{ name: 'author_id', type: 'string', optional: false },
				{ name: 'select', type: 'object', optional: true }
			]
		},
		update_conversations: {
			parameters: [
				{ name: 'session_id', type: 'integer', optional: false },
				{ name: 'data', type: 'object', optional: false },
				{ name: 'select', type: 'object', optional: true }
			]
		}
	}
}) as IConversationsService;

export interface SvcArgs {
	method: string;
	sessionid: number;
	site?: string;
	product?: string;
	data?: Message;
	author_id?: string;
	select?: Record<string, unknown>;
}

export interface SingleRpcService extends RpcService {
	reportsrpc(params: SvcArgs): Promise<Question[]>;
}

export const singleSvc: SingleRpcService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/reports/@@reports.rpc`,

	services: {
		reportsrpc: {
			cacheable: false,
			cacheLifetime: 24,
			parameters: [
				{ name: 'method', type: 'string', optional: false },
				{ name: 'sessionid', type: 'integer', optional: false },
				{ name: 'site', type: 'string', optional: true },
				{ name: 'data', type: 'object', optional: true },
				{ name: 'author_id', type: 'string', optional: true },
				{ name: 'select', type: 'Select', optional: true }
			]
		}
	}
}) as SingleRpcService;

export default svc;
